const validate = values => {
    const errors = {fuerzaVentaId: ''};
    if(!values.fuerzaVentaId){
        errors.fuerzaVentaId = 'Seleccione una fuerza de venta';
    }
    return errors;
};

export default validate;


// WEBPACK FOOTER //
// ./src/components/pages/prioritarios/configuracion/validate.ts